  import React, { useEffect } from 'react';
  import { motion, AnimatePresence } from 'framer-motion';
  import { useLocation } from 'react-router-dom';

  const PageTransitionWrapper = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
      // Enable smooth scrolling behavior
      document.documentElement.style.scrollBehavior = 'smooth';

      return () => {
        document.documentElement.style.scrollBehavior = 'auto';
      };
    }, []);

    // Page transition variants defined as a regular object
    const pageVariants = {
      initial: {
        opacity: 0,
        y: 10, // Slight upward movement
      },
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.3, // Shortened duration for faster transition
          ease: 'easeInOut',
        },
      },
      exit: {
        opacity: 0,
        y: -10, // Slight downward movement
        transition: {
          duration: 0.2, // Shortened duration for faster transition
          ease: 'easeInOut',
        },
      },
    };

    // Add scroll to top on page change
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageVariants}
          className="w-full min-h-screen"
        >
          {children}
        </motion.div>
      </AnimatePresence>
    );
  };

  export default PageTransitionWrapper;